import React, { useState, useRef } from "react";

import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import { GoInfo } from "react-icons/go";

import IconService from "icon-sdk-js/build/icon-sdk-js.web.min.js";

const TransferNFTModal = ({
  onChange,
  onClose,
  isVisible,
  address,
  setTransferNFTHandler,
  setNftTransferAddress

}) => {
  const inputRef = useRef();
  const [validation, setValidation] = useState(" ");

  const onTransferNFT = () => {
    onClose();
    setTransferNFTHandler();
  };

  const handleClose = (e) => {
    onClose();
    setValidation("");
    const value = e?.target.value.trim();

    if (value == "") {
      setValidation("Address field shouldn't be empty");
    }
  };

  const handleValidation = (e) => {
    const value = e?.target.value.trim();

    if (value == "") {
      setValidation("Address field shouldn't be empty");

    } else if (!value.startsWith("hx")) {
      setValidation("Address is invalid");
    } else if (value.length < 20) {
      setValidation("Address is invalid");
    } else if (value === address) {
      setValidation("You cannot transfer your NFT to your own address")
    }
    else {
      setValidation("")
      setNftTransferAddress(value.trim())
    }
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="name-modal card px-4 py-3"
    >
      <div className="header px-2 mb-1">
        <div className=" d-flex border-0 justify-content-between mb-0 flex-row">
          <h4 className="mb-2">
            Transfer NFT
          </h4>
          <span
            onClick={() => handleClose()}
            onKeyPress={(e) => e.code == "Enter" && handleClose()}
            className="close-modal"
          >
            <img src={MODAL_CLOSE.SOURCE} alt="close" />
          </span>
        </div>
      </div>
      <div className="body d-flex flex-column my-2 input-group">
        <div>
          <input
            type="text"
            autoComplete="off"
            className={`form-control ${validation !== "" && "error"}`}
            id="price"
            aria-describedby="price"
            placeholder="Enter Address"
            onChange={handleValidation}
            required
          />
        </div>
      </div>
      <p class="text-center text-danger mb-1">{validation}</p>
      <div className="footer text-center mt-2 pb-3">
        {console.log(validation)}
        <button
          autoComplete="off"
          className="btn btn-primary"
          disabled={validation != "" || validation == " "}
          onClick={onTransferNFT}
        >
          Transfer
        </button>
        {/* 
        <span className="helper-text text-center pt-2 d-block">
          *The price of Gangstar will be set on ICX.
        </span> */}
      </div>
    </Modal>
  );
};

export default TransferNFTModal;
